/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc
 */
import * as References from './OutOfOfficeHoursRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc#fetchOutOfOfficeStatuses
 */
export const FETCH_OUT_OF_OFFICE_STATUSES_QUERY_FIELD_NAME = 'com_hubspot_cv_assignments_rpc_OutOfOfficeHoursRpc_fetchOutOfOfficeStatuses';
export const FETCH_OUT_OF_OFFICE_STATUSES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_OUT_OF_OFFICE_STATUSES_QUERY_FIELD_NAME,
  args: ['userIds'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.fetchOutOfOfficeStatusesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});